
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"180","height":"136","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".9"}},[_c('rect',{attrs:{"x":"1","y":"1","width":"178","height":"134","rx":"13","fill":"#F4F6FA"}}),_c('path',{attrs:{"fill":"#A7A7A7","fill-opacity":".15","d":"M30 10h120v6H30zM30 102h120v6H30zM30 20h120v6H30zM30 112h120v6H30zM30 30h52v6H30zM30 122h120v6H30z"}}),_c('path',{attrs:{"opacity":".2","fill":"#9AA5BB","fill-opacity":".5","d":"M2 40h176v58H2z"}}),_c('rect',{attrs:{"x":"72","y":"92","width":"46","height":"35","rx":"6","transform":"rotate(-90 72 92)","fill":"#fff"}}),_c('rect',{attrs:{"x":"71","y":"93","width":"48","height":"37","rx":"7","transform":"rotate(-90 71 93)","stroke":"#F39","stroke-opacity":".6","stroke-width":"2"}}),_c('path',{attrs:{"d":"M70 66V50a6 6 0 016-6h27a6 6 0 016 6v16H70z","fill":"#A7A7A7","fill-opacity":".08"}}),_c('path',{attrs:{"opacity":".6","fill":"#A7A7A7","fill-opacity":".3","d":"M76 71h27v4H76zM76 79h15v4H76z"}}),_c('circle',{attrs:{"opacity":".7","cx":"58","cy":"68","r":"6","fill":"#9AA5BB","fill-opacity":".5"}}),_c('circle',{attrs:{"opacity":".7","cx":"121","cy":"68","r":"6","fill":"#9AA5BB","fill-opacity":".5"}})])])
          )
        }
      }
    